import locale from "localization/en";

export const dryStockMovementColumn = [
  {
    key: "itemCode",
    text: locale.itemCode,
  },
  {
    key: "product",
    text: locale.product,
  },
  {
    key: "variant",
    text: locale.variant,
  },
  {
    key: "type",
    text: locale.type,
  },
  {
    key: "actualBeginningInventory",
    text: locale.actualBeginningInventory,
    width: "200px",
  },
  {
    key: "delivery",
    text: locale.delivery,
  },
  {
    key: "sales",
    text: locale.sales,
  },
  {
    key: "returns",
    text: locale.returns,
  },
  {
    key: "expectedEndingInventory",
    text: locale.expectedEndingInventory,
  },
  {
    key: "actualEndingInventory",
    text: locale.actualEndingInventory,
    width: "200px",
  },
  {
    key: "variance",
    text: locale.variance,
  },
];
